import network from "@/domain/boilerRoom/network";
import busdToken from "@/domain/boilerRoom/otherTokens/busdToken";
import { METAMASK } from "../constants";
import saunaToken from "@/domain/boilerRoom/otherTokens/saunaToken";
import mintToken from "@/domain/boilerRoom/mintToken";
import { boilerPerBusd } from "../tokens";

export const getAccountData = async (web3, token, accountAddresses = []) => {
  try {
    let accounts =
      accountAddresses.length > 0
        ? accountAddresses
        : sessionStorage.getItem("provider") == METAMASK
        ? await _getAccountForMetaMask()
        : await web3.eth.getAccounts();

    let address = accounts[0];

    address = web3.utils.toChecksumAddress(address);
    let contract = new web3.eth.Contract(token.abi, token.contractAddress);

    let balance = await contract.methods
      .balanceOf(address)
      .call({ from: address });

    balance = web3.utils.toBN(balance).toString();

    let symbol = await contract.methods.symbol().call();

    return {
      address,
      balance,
      symbol,
    };
  } catch (e) {
    console.error(e);
    return null;
  }
};

export const getBoilerRoom = async (web3, accountAddress) => {
  try {
    let tokenContract = new web3.eth.Contract(
      mintToken.abi,
      mintToken.contractAddress
    );

    let maxSupply = await tokenContract.methods.maxSupply().call();
    let totalSupply = await tokenContract.methods.totalSupply().call();
    let isRedeemable = await tokenContract.methods.isEnableRedemption().call();
    let isMintable = await tokenContract.methods.isEnableMint().call();

    let stakedPeggedToken = await tokenContract.methods
      .stakedPeggedToken0()
      .call();
    let stakedPeggedTokenOne = await tokenContract.methods
      .stakedPeggedToken1()
      .call();

    let allFees = await tokenContract.methods.getFee().call();

    let mintingPerLimit = `${0}`;

    let account = {
      busdBalance: `${0}`,
      balance: `${0}`,
      saunaBalance: `${0}`,
      claimableMintsBalance: `${0}`,
      claimableRedemptionsBalance: {
        busdBalance: `${0}`,
        saunaBalance: `${0}`,
      },
      isApproved: false,
    };

    if (accountAddress) {
      let busdTokenContract = new web3.eth.Contract(
        busdToken.abi,
        busdToken.contractAddress
      );

      let accountBusdBalance = await busdTokenContract.methods
        .balanceOf(accountAddress)
        .call({ from: accountAddress });

      account.busdBalance = web3.utils.toBN(accountBusdBalance).toString();

      let balance = await tokenContract.methods
        .balanceOf(accountAddress)
        .call({ from: accountAddress });

      account.balance = web3.utils.toBN(balance).toString();

      let allowance = await busdTokenContract.methods
        .allowance(accountAddress, mintToken.contractAddress)
        .call({ from: accountAddress });

      account.isApproved = allowance > 0;

      mintingPerLimit = await tokenContract.methods
        .mintingLimitPerTime()
        .call({ from: accountAddress });

      let saunaTokenContract = new web3.eth.Contract(
        saunaToken.abi,
        saunaToken.contractAddress
      );

      let saunaBalance = await saunaTokenContract.methods
        .balanceOf(accountAddress)
        .call({ from: accountAddress });

      account.saunaBalance = web3.utils.toBN(saunaBalance).toString();

      let claimableMints = await tokenContract.methods
        .getClaimableMintsBalance(accountAddress)
        .call({ from: accountAddress });

      account.claimableMintsBalance = claimableMints.amount;

      let claimableRedemptions = await tokenContract.methods
        .getClaimableRedemptionsBalance(accountAddress)
        .call({ from: accountAddress });

      account.claimableRedemptionsBalance.busdBalance =
        claimableRedemptions.amount0;
      account.claimableRedemptionsBalance.saunaBalance =
        claimableRedemptions.amount1;
    }

    return {
      NETWORK: network.name,
      CHAIN_ID: network.chainIds[0],
      coinSymbol: mintToken.name,
      mainCoinImage: null,
      smallerCoinImage: null,
      stakeTokenAddress: mintToken.contractAddress,
      stakeTokenSymbol: mintToken.name,
      stakeTokenDecimals: mintToken.decimals,
      mintTokenAddress: mintToken.contractAddress,
      mintTokenSymbol: mintToken.name,
      mintTokenDecimals: mintToken.decimals,
      isMintable: isMintable,
      isRedeemable: isRedeemable,
      totalSupply: web3.utils.toBN(totalSupply).toString(),
      maxSupply: web3.utils.toBN(maxSupply).toString(),
      allFees: allFees,
      stakedPeggedToken: web3.utils.toBN(stakedPeggedToken).toString(),
      stakedPeggedTokenOne: web3.utils.toBN(stakedPeggedTokenOne).toString(),
      mintingPerLimit: web3.utils.toBN(mintingPerLimit).toString(),
      status: "ACTIVE",
      isMaster: false,
      isFrozen: false,
      isFinished: false,
      account,
      createdAt: new Date().getTime(),
      updatedAt: new Date().getTime(),
    };
  } catch (e) {
    console.error(e);
  }
};

export const addToMetamask = async (web3) => {
  let tokenContract = new web3.eth.Contract(
    mintToken.abi,
    mintToken.contractAddress
  );

  let symbol = await tokenContract.methods.symbol().call();
  let decimals = await tokenContract.methods.decimals().call();
  let image = null;

  try {
    const isAdded = await window.ethereum.request({
      method: "wallet_watchAsset",
      params: {
        type: "ERC20",
        options: {
          address: mintToken.contractAddress,
          symbol: symbol,
          decimals: decimals,
          image: image,
        },
      },
    });

    return isAdded;
  } catch (e) {
    console.error(e);
  }
};

export const _getAccountForMetaMask = async () => {
  if (!window.ethereum) return;

  let accounts = [];
  await window.ethereum
    .request({
      method: "eth_requestAccounts",
    })
    .then(async (acts) => {
      accounts = acts;
    })
    .catch((error) => {
      if (error.code === 4001) {
        console.log("Permissions needed to continue.");
      } else {
        console.log(error);
      }
      accounts = [];
    });

  return accounts;
};

export const getBoilerPrice = async (web3) => {
  return 1 / await boilerPerBusd(web3);
};
